import React, { MouseEventHandler, VFC } from 'react';
import styled from 'styled-components';
import useTheme from '@material-ui/core/styles/useTheme';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import ClearButton from './ClearButton';

const ClearButtonWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 24px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    right: 16px;
  }
`;

interface Props extends DialogProps {
  onClickClear: MouseEventHandler<HTMLButtonElement>;
}
const DialogWithClose: VFC<Props> = ({
  onClickClear,
  children,
  ...rest
}: Props) => {
  const theme = useTheme();
  return (
    <Dialog {...rest}>
      <ClearButtonWrapper theme={theme}>
        <ClearButton onClick={onClickClear} />
      </ClearButtonWrapper>
      {children}
    </Dialog>
  );
};

export default DialogWithClose;
